import { ICasinoReport } from 'reduxStore/models/casinoModels';
import { parseValue } from 'common/include';
import { getBankName } from 'common/common';
import { insightGameInfo, isInsightCardRow } from 'services/insightCasino';
import { InsightFilterEnum } from 'reduxStore/models/favoritesModels';

export interface GameInformationProps {
  manufacturer: string;
  bank: string;
  /** DISPLAY id: matched machines.slotNumber via GetSearchData catalog, else mnum / slot_number. */
  slotNumber: number | string;
  type: string;
  pop: any;
  volatility: any;
  denom: string;
  rating: string;
}

/**
 * Maps the Details report row into Game Info fields.
 * Insight Slot = egmCardNumber → displayIdForInsightMnum (GetSearchData machines
 * catalog). Never ISlotData.slotNumber (mnum) and never insight-row slotNumber.
 */
export const mapCasinoReportToGameInfo = (report: ICasinoReport): GameInformationProps => {
  if (!report) {
    return {
      manufacturer: 'N/A',
      bank: 'N/A',
      slotNumber: 0,
      type: 'N/A',
      pop: 'N/A',
      volatility: 'N/A',
      denom: 'N/A',
      rating: 'N/A',
    };
  }
  const insightInfo = isInsightCardRow(report) ? insightGameInfo(report) : null;
  return {
    manufacturer: report.manufacturer,
    bank: insightInfo ? insightInfo.bank : getBankName(report.area, report.section),
    slotNumber: insightInfo ? insightInfo.slotNumber : report.slot_number,
    type: report.progressive_type_desc,
    pop: parseValue(report.pop, InsightFilterEnum.PayoutToPlayer),
    volatility: parseValue(report.volatility_rating_ntile, InsightFilterEnum.Volatility),
    denom: report.denomination,
    rating: '4.6 Stars',
  };
};
